import { createStore, applyMiddleware, compose } from 'redux';
import allReducer from './reducers/index';
import thunk from 'redux-thunk';
import { batchedSubscribe } from 'redux-batched-subscribe';

const initialState = {};
const middleware = [thunk];

const store = createStore(
    allReducer,
    initialState,
    compose(
        applyMiddleware(...middleware),
        batchedSubscribe( (notify) => {
            notify();
        }),
        typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "undefined"
        ? a => a
        : window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__()        

    )

    //REMOVE FROM COMPOSE IN PROD VERSION
    // typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "undefined"
    // ? a => a
    // : window.__REDUX_DEVTOOLS_EXTENSION__ &&
    //     window.__REDUX_DEVTOOLS_EXTENSION__()
    
  );
  
  export default store;